import dynamic from 'next/dynamic'
import React, { useRef } from 'react'
import { IoAppsSharp as IoAppsSharpOriginal, IoArrowForward } from 'react-icons/io5'
import { useClickAway, useMedia } from 'react-use'
import styled from 'styled-components'
import { media, phoneMaxWidth } from 'utils/media'
import { Link } from 'lib/Link'
import { MaxWidthContainer } from 'lib/Section'
import { Text } from 'lib/Text'
import { SearchInput } from 'modules/brands/list/components/SearchInput'
import { AlgoliaSearchProvider, useAlgoliaSearchContext } from 'modules/brands/list/components/controllers/AlgoliaSearchContext'

const SearchModalDesktop = dynamic(() => import('modules/brands/list/components/SearchModalDesktop').then((res) => res.SearchModalDesktop))
const SearchModalMobile = dynamic(() => import('modules/brands/list/components/SearchModalMobile').then((res) => res.SearchModalMobile))

const SearchContainer = styled.div`
  max-width: 480px;
  position: relative;
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: none;
  gap: 10px;
  color: var(--black-100);
  padding: 12px 16px;
  width: fit-content;

  :hover {
    border: none;
    background: var(--black-15);
  }
`

const Container = styled(MaxWidthContainer)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 64px var(--wide-grid-spacing);
  padding-bottom: 0;

  ${media.phoneUp} {
    padding: 80px var(--wide-grid-spacing);
    padding-bottom: 40px;
  }
`

const Title = styled(Text)`
  max-width: 600px;
  margin-bottom: 28px;

  ${media.phoneUp} {
    margin-bottom: 36px;
  }
`

const BrowseText = styled(Text)`
  white-space: nowrap;
`

const IoAppsSharp = styled(IoAppsSharpOriginal)`
  ${media.tinyPhoneDown} {
    display: none;
  }
`

const SearchSection = () => {
  const { closeModal } = useAlgoliaSearchContext()

  const searchContainerRef = useRef(null)

  useClickAway(searchContainerRef, () => {
    closeModal()
  })

  const isMobile = useMedia(`(max-width: ${phoneMaxWidth}px)`)

  return (
    <SearchContainer ref={searchContainerRef}>
      <SearchInput placeholder="Search brands or products" searchBlankOnClose={false} />

      {isMobile ? <SearchModalMobile /> : <SearchModalDesktop />}
    </SearchContainer>
  )
}

export const SearchHeader = () => {
  return (
    <Container as="section">
      <Title as="h1" size="xl">
        Your go-to place to discover and review online brands.
      </Title>

      <AlgoliaSearchProvider>
        <SearchSection />
      </AlgoliaSearchProvider>

      <StyledLink href="/brands">
        <IoAppsSharp size={24} />
        <BrowseText weight="semi" size="ps" as="p">
          Browse the directory
        </BrowseText>
        <IoArrowForward size={24} />
      </StyledLink>
    </Container>
  )
}
